export const PRIVILEGE_VIEW_RECENT_USER_ACTIVITY = "VIEW_RECENT_USER_ACTIVITY";
export const PRIVILEGE_VIEW_ASSIGNED_ROLE_PRIVILEGES = "VIEW_ASSIGNED_ROLE_PRIVILEGES";
export const PRIVILEGE_CREATE_NEW_PRIVILEGE = "CREATE_NEW_PRIVILEGE";
export const PRIVILEGE_CREATE_NEW_ROLE = "CREATE_NEW_ROLE";
export const PRIVILEGE_MANUALLY_RUN_INVOICE_CREATION_JOB =
  "MANUALLY_RUN_INVOICE_CREATION_JOB";
export const PRIVILEGE_VIEW_ALL_CLIENTS = "VIEW_ALL_CLIENTS";
export const PRIVILEGE_OFFER_CATALOG_ADD_SERVICE_BUTTON =
  "OFFER_CATALOG_ADD_SERVICE_BUTTON";
export const PRIVILEGE_EDIT_CLIENT_CONFIGURATION = "EDIT_CLIENT_CONFIGURATION";

/** @param {unknown} decodedToken */
export function jwtPrivileges(decodedToken) {
  const privileges = decodedToken?.privileges;
  if (!Array.isArray(privileges)) {
    return [];
  }
  return privileges.map((p) => String(p ?? "").trim()).filter(Boolean);
}

/** @param {unknown} decodedToken @param {string} privilegeName */
export function hasPrivilege(decodedToken, privilegeName) {
  const target = String(privilegeName ?? "").trim().toUpperCase();
  if (!target) {
    return false;
  }
  return jwtPrivileges(decodedToken).some((p) => p.toUpperCase() === target);
}

/** @param {unknown} decodedToken */
export function hasViewRecentUserActivityPrivilege(decodedToken) {
  return hasPrivilege(decodedToken, PRIVILEGE_VIEW_RECENT_USER_ACTIVITY);
}

/** @param {unknown} decodedToken */
export function hasViewAssignedRolePrivileges(decodedToken) {
  return hasPrivilege(decodedToken, PRIVILEGE_VIEW_ASSIGNED_ROLE_PRIVILEGES);
}

/** @param {unknown} decodedToken */
export function hasCreateNewPrivilege(decodedToken) {
  return hasPrivilege(decodedToken, PRIVILEGE_CREATE_NEW_PRIVILEGE);
}

/** @param {unknown} decodedToken */
export function hasCreateNewRole(decodedToken) {
  return hasPrivilege(decodedToken, PRIVILEGE_CREATE_NEW_ROLE);
}

/** @param {unknown} decodedToken */
export function hasManuallyRunInvoiceCreationJobPrivilege(decodedToken) {
  return hasPrivilege(decodedToken, PRIVILEGE_MANUALLY_RUN_INVOICE_CREATION_JOB);
}

/** @param {unknown} decodedToken */
export function hasViewAllClientsPrivilege(decodedToken) {
  return hasPrivilege(decodedToken, PRIVILEGE_VIEW_ALL_CLIENTS);
}

/** @param {unknown} decodedToken */
export function hasOfferCatalogAddServiceButtonPrivilege(decodedToken) {
  return hasPrivilege(decodedToken, PRIVILEGE_OFFER_CATALOG_ADD_SERVICE_BUTTON);
}

/** @param {unknown} decodedToken */
export function hasEditClientConfigurationPrivilege(decodedToken) {
  return hasPrivilege(decodedToken, PRIVILEGE_EDIT_CLIENT_CONFIGURATION);
}
